import React from "react";
import { ShimmerButton, ShimmerCategoryList, ShimmerTitle } from "react-shimmer-effects";
var AssignmentNewSkeletalLoader = function AssignmentNewSkeletalLoader() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement(ShimmerTitle, {
    line: 1,
    gap: 10,
    variant: "primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(ShimmerCategoryList, {
    title: true,
    items: 8,
    categoryStyle: "STYLE_ONE"
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, /*#__PURE__*/React.createElement(ShimmerButton, {
    size: "sm"
  })), /*#__PURE__*/React.createElement(ShimmerButton, {
    size: "sm"
  })))));
};
export default AssignmentNewSkeletalLoader;